const scale = 2.25;
export const Settings = {
  border_radius: 4 * scale,
  border_radius_pill: 10 * scale,
};